import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-error-dialog',
  templateUrl: './error-dialog.component.html',
  styleUrls: ['./error-dialog.component.css']
})
export class ErrorDialogComponent implements OnInit {

  dialogInfo: any;
  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
              private authService: AuthService) { }

  ngOnInit(): void {
      this.dialogInfo = this.data;
  }

  logout(): void {
    this.authService.logout();   
  }
}
